import { render, staticRenderFns } from "./KPZLHTJGPZZHTGZSQ.vue?vue&type=template&id=36672407&scoped=true"
import script from "./KPZLHTJGPZZHTGZSQ.vue?vue&type=script&lang=js"
export * from "./KPZLHTJGPZZHTGZSQ.vue?vue&type=script&lang=js"
import style0 from "./KPZLHTJGPZZHTGZSQ.vue?vue&type=style&index=0&id=36672407&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36672407",
  null
  
)

export default component.exports